<template>
  <div class="content-box">
    <div class="d-flex justify-content-center">
      <b-spinner variant="success" label="Spinning" v-if="showSpinner" style="width: 3rem; height: 3rem"></b-spinner>
    </div>
    <b-tabs vertical content-class="col-12 col-md-9 mt-1 mt-md-0" pills nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left" v-if="!showSpinner">

      <b-tab v-if="IsAdmin()">
        <!-- Account Set Up  -->
        <template #title>
          <feather-icon icon="ToolIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Set Up My Account</span>
        </template>
        <AccountSetUp @goToTab="goToTab"/>
      </b-tab>
      <!-- general tab -->
      <b-tab active>
        <!-- title -->
        <template #title>
          <feather-icon icon="UserIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">General</span>
        </template>

        <account-setting-general :general-data="options" />
      </b-tab>
      <!--/ general tab -->

      <!-- change password tab -->
      <b-tab :active="(isAccountSettingRoute && (activeTab == undefined || activeTab == null))">
        <!-- title -->
        <template #title>
          <feather-icon icon="LockIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Change Password</span>
        </template>

        <account-setting-password />
      </b-tab>
      <!--/ change password tab -->

      <!-- change password tab -->
      <b-tab>
        <!-- title -->
        <template #title>
          <feather-icon icon="LockIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">My Permissions</span>
        </template>

        <account-setting-permissions :permissions="permissions" />
      </b-tab>
      <!--/ change password tab -->

      <!-- info -->
      <b-tab v-if="IsAdmin()">
        <!-- title -->
        <template #title>
          <feather-icon icon="InfoIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Audit Logs</span>
        </template>

        <account-setting-information :informationData="logs" />
      </b-tab>

      <b-tab v-if="IsAdmin() && HasPermission(PermissionList.Inventory_View)">
        <template #title>
          <feather-icon icon="InfoIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Units of Measure</span>
        </template>

        <account-setting-uom />
      </b-tab>

      <!-- <b-tab>
        <template #title>
          <feather-icon icon="SettingsIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Module Configuration</span>
        </template>
        <AccountSettingModuleConfig />
      </b-tab> -->


      <b-tab v-if="IsAdmin() && HasPermission(PermissionList.Marketing_View)" :active="(activeTab == 'facebook')">
        <!-- title -->
        <template #title>
          <feather-icon icon="LockIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">My Social</span>
        </template>

        <AccountAppid />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="UploadIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Upload / Download Center</span>
        </template>
        <UploadCenter />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="UsersIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Labours</span>
        </template>
        <b-card>
          <LabourComponent />
        </b-card>
      </b-tab>
      <b-tab v-if="IsAdmin()">
        <template #title>
          <feather-icon icon="SettingsIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Custom Fields</span>
        </template>
        <CustomFields />
      </b-tab>
      <b-tab v-if="IsAdmin()" :active="(activeTab == 'companySettings')">
        <template #title>
          <feather-icon icon="SettingsIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Company Settings</span>
        </template>
        <AccountSettingCompanySettings />
      </b-tab>
      <b-tab v-if="IsAdmin()">
        <template #title>
          <feather-icon icon="SettingsIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Transaction Setting</span>
        </template>
        <Invoice />
      </b-tab>
    
    </b-tabs>
  </div>
</template>

<script>
import api from "@/api/api-v1-config";
import { BTabs, BTab, BSpinner, BCard } from "bootstrap-vue";
import AccountSettingGeneral from "./AccountSettingGeneral.vue";
import AccountSettingPassword from "./AccountSettingPassword.vue";
import AccountSettingInformation from "./AccountSettingInformation.vue";
import AccountSettingSocial from "./AccountSettingSocial.vue";
import AccountSettingNotification from "./AccountSettingNotification.vue";
import AccountSettingPermissions from "./AccountSettingPermissions.vue";
import AccountSettingUom from "./AccountSettingUOM.vue";
import AccountSettingCompanySettings from "./AccountSettingCompanySettings.vue";
import AccountAppid from "./AccountAppid.vue";
import UploadCenter from "./UploadCenter.vue";
import DownloadCenter from "./DownloadCenter.vue";
import LabourComponent from "@/views/inventory/labour/TableListClients.vue";
import CustomFields from "./CustomFieldsSettings.vue";
import Invoice from "./InvoiceSettings.vue";
import AccountSettingModuleConfig from "./AccountSettingModuleConfig.vue";
import AccountSetUp from "./AccountSetUp.vue";
import { IsAdmin, HasPermission } from "@/@core/utils/validations/permissionCheck";
import { PermissionList } from "@/libs/defaultList";

import { concat } from "lodash";

export default {
  components: {
    BTabs,
    BTab,
    BSpinner,
    BCard,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingInformation,
    AccountSettingSocial,
    AccountSettingNotification,
    AccountSettingPermissions,
    AccountSettingUom,
    AccountSettingCompanySettings,
    AccountSetUp,
    AccountAppid,
    UploadCenter,
    DownloadCenter,
    LabourComponent,
    CustomFields,
    Invoice,
    AccountSettingModuleConfig
  },
  data() {
    return {
      token: localStorage.getItem("accessToken"),
      activeTab: this.$route.meta.activeTab,
      showSpinner: true,
      options: [],
      logs: [],
      permissions: [],
      isAccountSettingRoute: false,
    };
  },
  methods: {
    async getProfile() {
      let conf = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
      };
      await api
        .get("/personal/profile", conf)

        .then((response) => {
          this.options = response.data.result;
          this.showSpinner = false;
        })
        .catch((error) => {
          console.log(error);
          this.showSpinner = false;
        });
    },

    async getLogs() {
      let conf = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
      };
      await api
        .get("/personal/logs", conf)

        .then((response) => {
          this.logs = response.data;
          console.log("🚀 ~ file: AccountSetting.vue:222 ~ .then ~ this.log:", this.logs)

          this.showSpinner = false;
        })
        .catch((error) => {
          console.log(error);
          this.showSpinner = false;
        });
    },

    getFromLocalStorage() {
      var userData = JSON.parse(localStorage.getItem("userData"));

      if (userData.has_default_password) {
        this.isAccountSettingRoute = true;
      } else {
        this.isAccountSettingRoute = false;
      }
    },

    async getPermissions() {
      let conf = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.token,
        },
      };
      await api
        .get("/personal/permissions", conf)

        .then((response) => {
          this.permissions = response.data.result;
          console.log(this.permissions);

          this.showSpinner = false;
        })
        .catch((error) => {
          console.log(error);
          this.showSpinner = false;
        });
    },
    async goToTab(index){
      this.activeTab = index;
    }
  },

  async mounted() {
    this.getFromLocalStorage();
    await this.getLogs();
    await this.getProfile();
    this.getPermissions();
  },
  setup(){
    return{
      PermissionList,
      HasPermission,
      IsAdmin,
    }
  }
};
</script>
